import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";

import { Row, Col, Form, InputGroup, Modal, Container } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import {
  AllCity,
  AllVehicleBodyType,
  AllVehicleByCategory,
  AllVehicleCategory,
  VehicleCategory,
} from "../../../../utils/apis/masters/masters";
import { Context } from "../../../../utils/context";
import ModalSave from "../../../common/ModalSave";
import { CancelButton, SaveButton } from "../../../common/Button";
library.add(fas);
const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data, IMG_URL } = useContext(Context);

  const [city, setCity] = useState([]);
  const [vehicleCategory, setVehicleCategory] = useState([]);
  const [vehicle, setVehicle] = useState([]);
  const [vehicleBodyType, setVehicleBodyType] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
  } = useForm();

  const GetAllCity = async () => {
    const response = await AllCity();

    if (response?.success) {
      setCity(await Select2Data(response?.data, "city_id"));
    }
  };

  const GetAllVehicleCategory = async () => {
    const response = await AllVehicleCategory();

    if (response?.success) {
      setVehicleCategory(
        await Select2Data(response?.data, "vehicle_category_id")
      );
    }
  };

  const GetAllVehicleByCategory = async (id) => {
    const response = await AllVehicleByCategory(id);

    if (response?.success) {
      setVehicle(await Select2Data(response?.data, "vehicle_id"));
    }
  };

  const GetAllVehicleBodyType = async (id) => {
    const response = await AllVehicleBodyType(id);

    if (response?.success) {
      setVehicleBodyType(await Select2Data(response?.data, "vehicle_body_id"));
    }
  };

  useEffect(() => {
    GetAllCity();
    GetAllVehicleCategory();
    GetAllVehicleBodyType();
  }, []);

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append(
        "vehicle_category_id",
        data?.vehicle_category_id?.value
      );
      DataToSend.append("vehicle_id", data?.vehicle_id?.value);
      DataToSend.append("vehicle_body_id", data?.vehicle_body_id?.value);
      DataToSend.append("city_id", data?.city_id?.value);
      DataToSend.append("f_name", data?.f_name);
      DataToSend.append("email", data?.email || null);
      DataToSend.append("contact_no", data?.contact_no);
      DataToSend.append("owner_no", data?.owner_no);
      DataToSend.append("adhar_card", data?.adhar_card[0]);
      DataToSend.append("adhar_card_back", data?.adhar_card_back[0]);
      DataToSend.append("pan_card", data?.pan_card[0]);
      DataToSend.append("pan_card_back", data?.pan_card_back[0]);
      DataToSend.append("driving_license", data?.driving_licence[0]);
      DataToSend.append("driving_license_back", data?.driving_license_back[0]);
      DataToSend.append("vehicle_rc", data?.vehicle_rc[0]);
      DataToSend.append("vehicle_rc_back", data?.vehicle_rc_back[0]);
      DataToSend.append("car_image_front", data?.car_image_front[0]);
      DataToSend.append("car_image_back", data?.car_image_back[0]);
      DataToSend.append("puc_image", data?.puc_image[0]);
      DataToSend.append("bank_detail_image", data?.bank_detail_image[0]);
      DataToSend.append("insurance_image", data?.insurance_image[0]);

      const response = await postData(`/customers/driver`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [aadharPreview, setAadharPreview] = useState(null);
  const [aadharBackPreview, setAadharBackPreview] = useState(null);
  const [panPreview, setpanPreview] = useState(null);
  const [panBackPreview, setpanBackPreview] = useState(null);
  const [drivingLicencePreview, setDrivingLicencePreview] = useState(null);
  const [drivingLicenceBackPreview, setDrivingLicenceBackPreview] =
    useState(null);
  const [vehicleRCPreview, setVehicleRCPreview] = useState(null);
  const [vehicleRCBackPreview, setVehicleRCBackPreview] = useState(null);

  const [CarImageFrontPreview, setCarImageFrontPreview] = useState(null);
  const [CarImageBackPreview, setCarImageBackPreview] = useState(null);
  const [pucImagePreview, setPucImagePreview] = useState(null);
  const [bankDetailImagePreview, setBankDetailImagePreview] = useState(null);
  const [insuranceImagePreview, setInsuranceImagePreview] = useState(null);

  const handleAadharChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAadharPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAadharBackChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAadharBackPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePanChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setpanPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePanBackChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setpanBackPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDrivingLicenceChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setDrivingLicencePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDrivingLicenceBackChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setDrivingLicenceBackPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleVehicleRCChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setVehicleRCPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleVehicleRCBackChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setVehicleRCBackPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCarImageFrontChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setCarImageFrontPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCarImageBackChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setCarImageBackPreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePucImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPucImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleBankDetailImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBankDetailImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const handleInsuranceImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setInsuranceImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };

  const [charCount, setCharCount] = useState(0);
  const maxCharLimit = 100;

  const handleInputChange = (e) => {
    setCharCount(e.target.value.length);
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton>
          {/* <Offcanvas.Title>Add User Help Type</Offcanvas.Title> */}
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded ">
            <Card.Body>
              <Card.Title>Add Driver </Card.Title>
              <hr />
              <Container>
                <Row>
                  <Col md={12}>
                    <Container>
                      <Row className="">
                        <Col xxl={12} xl={12} md={10}>
                          <Form
                            onSubmit={() => handleSubmit(onSubmit)}
                            role="form"
                            className="blogfeedclass"
                          >
                            <Row>
                              <Col
                                lg={8}
                                md={10}
                                className=" mx-auto Add-content"
                              >
                                <Row>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="justify-content-center">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Group>
                                          <InputGroup>
                                            <Form.Control
                                              type="text"
                                              name="f_name"
                                              placeholder="Name"
                                              className={classNames("", {
                                                "is-invalid": errors?.f_name,
                                              })}
                                              {...register("f_name", {
                                                required: "Name is required",
                                                maxLength: {
                                                  value: maxCharLimit,
                                                  message: `Name cannot exceed ${maxCharLimit} characters`,
                                                },
                                              })}
                                              maxLength={maxCharLimit}
                                              onChange={(e) => {
                                                handleInputChange(e); // Your existing handler
                                                clearErrors("f_name"); // Clears error when user starts typing
                                              }}
                                            />
                                          </InputGroup>
                                          <div className="text-end">
                                            <small>
                                              {maxCharLimit} characters Limit{" "}
                                            </small>
                                          </div>

                                          {errors.f_name && (
                                            <span className="text-danger">
                                              {errors.f_name.message}
                                            </span>
                                          )}
                                        </Form.Group>
                                      </Row>
                                    </div>
                                  </Col>{" "}
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="justify-content-center">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Group>
                                          <InputGroup>
                                            <Form.Control
                                              type="text"
                                              name="email"
                                              placeholder="Enter email"
                                              className={classNames("", {
                                                "is-invalid": errors?.email,
                                              })}
                                              {...register("email", {
                                                required: "Email is required",
                                                pattern: {
                                                  value:
                                                    /^[a-zA-Z0-9._%+-]+@{1}[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                                  message:
                                                    "Invalid email format",
                                                },
                                              })}
                                              onChange={(e) => {
                                                clearErrors("email");
                                              }}
                                            />
                                          </InputGroup>

                                          {errors.email && (
                                            <span className="text-danger">
                                              {errors.email.message}
                                            </span>
                                          )}
                                        </Form.Group>
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="justify-content-center">
                                        <Form.Label>Contact No</Form.Label>
                                        <Form.Group>
                                          <InputGroup>
                                            <Form.Control
                                              type="text"
                                              name="contact_no"
                                              placeholder="Contact No"
                                              maxLength={10}
                                              className={classNames("", {
                                                "is-invalid":
                                                  errors?.contact_no,
                                              })}
                                              {...register("contact_no", {
                                                required:
                                                  "Contact No is required",
                                                pattern: {
                                                  value: /^[0-9]{10}$/,
                                                  message:
                                                    "Invalid contact number. Must be 10 digits.",
                                                },
                                              })}
                                              onChange={() => {
                                                clearErrors("contact_no");
                                              }}
                                              onInput={(e) => {
                                                e.target.value =
                                                  e.target.value.replace(
                                                    /[^0-9]/g,
                                                    ""
                                                  );
                                              }}
                                            />
                                          </InputGroup>

                                          {errors.contact_no && (
                                            <span className="text-danger">
                                              {errors.contact_no.message}
                                            </span>
                                          )}
                                        </Form.Group>
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="justify-content-center">
                                        <Form.Label>
                                          Owner Contact No
                                        </Form.Label>
                                        <Form.Group>
                                          <InputGroup>
                                            <Form.Control
                                              type="text"
                                              name="owner_no"
                                              placeholder="Owner Contact No"
                                              maxLength={10}
                                              className={classNames("", {
                                                "is-invalid": errors?.owner_no,
                                              })}
                                              {...register("owner_no", {
                                                required:
                                                  "Owner Contact is required",
                                                pattern: {
                                                  value: /^[0-9]{10}$/,
                                                  message:
                                                    "Invalid contact number. Must be 10 digits.",
                                                },
                                              })}
                                              onChange={() => {
                                                clearErrors("owner_no");
                                              }}
                                              onInput={(e) => {
                                                e.target.value =
                                                  e.target.value.replace(
                                                    /[^0-9]/g,
                                                    ""
                                                  );
                                              }}
                                            />
                                          </InputGroup>

                                          {errors.owner_no && (
                                            <span className="text-danger">
                                              {errors.owner_no.message}
                                            </span>
                                          )}
                                        </Form.Group>
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="row justify-content-center mb-2">
                                        <Form.Label>City</Form.Label>
                                        <Controller
                                          name="city_id" // name of the field
                                          {...register("city_id", {
                                            required: "Select City",
                                          })}
                                          control={control}
                                          render={({ field }) => (
                                            <Select
                                              styles={{
                                                control: (baseStyles) => ({
                                                  ...baseStyles,
                                                  borderColor: errors.city_id
                                                    ? "red"
                                                    : baseStyles,
                                                }),
                                              }}
                                              {...field}
                                              options={city}
                                            />
                                          )}
                                        />
                                        {errors.city_id && (
                                          <span className="text-danger">
                                            {errors.city_id.message}
                                          </span>
                                        )}
                                      </Row>
                                    </div>
                                  </Col>{" "}
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="row justify-content-center mb-2">
                                        <Form.Label>
                                          Vehicle Category
                                        </Form.Label>
                                        <Controller
                                          name="vehicle_category_id" // name of the field
                                          {...register("vehicle_category_id", {
                                            required: "Select Vehicle Category",
                                          })}
                                          control={control}
                                          render={({ field }) => (
                                            <Select
                                              styles={{
                                                control: (baseStyles) => ({
                                                  ...baseStyles,
                                                  borderColor:
                                                    errors.vehicle_category_id
                                                      ? "red"
                                                      : baseStyles,
                                                }),
                                              }}
                                              {...field}
                                              options={vehicleCategory}
                                              onChange={(selectedOption) => {
                                                field.onChange(selectedOption);
                                                GetAllVehicleByCategory(
                                                  selectedOption.value
                                                );
                                                setValue("vehicle_id", "");
                                              }}
                                            />
                                          )}
                                        />
                                        {errors.vehicle_category_id && (
                                          <span className="text-danger">
                                            {errors.vehicle_category_id.message}
                                          </span>
                                        )}
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="row justify-content-center mb-2">
                                        <Form.Label>Vehicle</Form.Label>
                                        <Controller
                                          name="vehicle_id" // name of the field
                                          {...register("vehicle_id", {
                                            required: "Select Vehicle",
                                          })}
                                          control={control}
                                          render={({ field }) => (
                                            <Select
                                              styles={{
                                                control: (baseStyles) => ({
                                                  ...baseStyles,
                                                  borderColor: errors.vehicle_id
                                                    ? "red"
                                                    : baseStyles,
                                                }),
                                              }}
                                              {...field}
                                              options={vehicle}
                                            />
                                          )}
                                        />
                                        {errors.vehicle_id && (
                                          <span className="text-danger">
                                            {errors.vehicle_id.message}
                                          </span>
                                        )}
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Row className="row justify-content-center mb-2">
                                        <Form.Label>
                                          Vehicle Body Type
                                        </Form.Label>
                                        <Controller
                                          name="vehicle_body_id" // name of the field
                                          {...register("vehicle_body_id", {
                                            required:
                                              "Select Vehicle Body Type",
                                          })}
                                          control={control}
                                          render={({ field }) => (
                                            <Select
                                              styles={{
                                                control: (baseStyles) => ({
                                                  ...baseStyles,
                                                  borderColor:
                                                    errors.vehicle_body_id
                                                      ? "red"
                                                      : baseStyles,
                                                }),
                                              }}
                                              {...field}
                                              options={vehicleBodyType}
                                            />
                                          )}
                                        />
                                        {errors.vehicle_body_id && (
                                          <span className="text-danger">
                                            {errors.vehicle_body_id.message}
                                          </span>
                                        )}
                                      </Row>
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3"></div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>Aadhar Card</Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Image"
                                            className={classNames("", {
                                              "is-invalid": errors?.adhar_card,
                                            })}
                                            {...register("adhar_card", {
                                              required:
                                                "Aadhar Card is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handleAadharChange(e); // Your existing handler
                                              clearErrors("adhar_card"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.adhar_card && (
                                          <span className="text-danger">
                                            {errors.adhar_card.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {aadharPreview && (
                                        <div className="mt-2">
                                          <img
                                            src={aadharPreview}
                                            alt="Aadhar Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>

                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>
                                            Aadhar Card Back
                                          </Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Image"
                                            className={classNames("", {
                                              "is-invalid":
                                                errors?.adhar_card_back,
                                            })}
                                            {...register("adhar_card_back", {
                                              required:
                                                "Aadhar Card Back is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handleAadharBackChange(e); // Your existing handler
                                              clearErrors("adhar_card_back"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.adhar_card_back && (
                                          <span className="text-danger">
                                            {errors.adhar_card_back.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {aadharBackPreview && (
                                        <div className="mt-2">
                                          <img
                                            src={aadharBackPreview}
                                            alt="Aadhar Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>Pan Card</Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Image"
                                            className={classNames("", {
                                              "is-invalid": errors?.pan_card,
                                            })}
                                            {...register("pan_card", {
                                              required: "Pan Card is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handlePanChange(e); // Your existing handler
                                              clearErrors("pan_card"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.pan_card && (
                                          <span className="text-danger">
                                            {errors.pan_card.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {panPreview && (
                                        <div className="mt-2">
                                          <img
                                            src={panPreview}
                                            alt="Aadhar Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>

                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>Pan Card Back</Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Image"
                                            className={classNames("", {
                                              "is-invalid":
                                                errors?.pan_card_back,
                                            })}
                                            {...register("pan_card_back", {
                                              required:
                                                "Pan Card Back is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handlePanBackChange(e); // Your existing handler
                                              clearErrors("pan_card_back"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.pan_card_back && (
                                          <span className="text-danger">
                                            {errors.pan_card_back.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {panBackPreview && (
                                        <div className="mt-2">
                                          <img
                                            src={panBackPreview}
                                            alt="Pan Back Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>
                                            Driving Licence
                                          </Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Image"
                                            className={classNames("", {
                                              "is-invalid":
                                                errors?.driving_licence,
                                            })}
                                            {...register("driving_licence", {
                                              required:
                                                "Driving Licence is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handleDrivingLicenceChange(e); // Your existing handler
                                              clearErrors("driving_licence"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.driving_licence && (
                                          <span className="text-danger">
                                            {errors.driving_licence?.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {drivingLicencePreview && (
                                        <div className="mt-2">
                                          <img
                                            src={drivingLicencePreview}
                                            alt="Aadhar Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>

                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>
                                            Driving Licence Back
                                          </Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Image"
                                            className={classNames("", {
                                              "is-invalid":
                                                errors?.driving_license_back,
                                            })}
                                            {...register(
                                              "driving_license_back",
                                              {
                                                required:
                                                  "Driving Licence Back is required",
                                              }
                                            )}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handleDrivingLicenceBackChange(e); // Your existing handler
                                              clearErrors(
                                                "driving_license_back"
                                              ); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.driving_license_back && (
                                          <span className="text-danger">
                                            {
                                              errors.driving_license_back
                                                ?.message
                                            }
                                          </span>
                                        )}
                                      </Form.Group>
                                      {drivingLicenceBackPreview && (
                                        <div className="mt-2">
                                          <img
                                            src={drivingLicenceBackPreview}
                                            alt="Aadhar Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>Vehicle Rc</Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Vehicle RC"
                                            className={classNames("", {
                                              "is-invalid": errors?.vehicle_rc,
                                            })}
                                            {...register("vehicle_rc", {
                                              required:
                                                "Vehicle RC is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handleVehicleRCChange(e); // Your existing handler
                                              clearErrors("vehicle_rc"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.vehicle_rc && (
                                          <span className="text-danger">
                                            {errors.vehicle_rc.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {vehicleRCPreview && (
                                        <div className="mt-2">
                                          <img
                                            src={vehicleRCPreview}
                                            alt="Vehicle RC Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>

                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>
                                            Vehicle Rc Back
                                          </Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Vehicle RC"
                                            className={classNames("", {
                                              "is-invalid":
                                                errors?.vehicle_rc_back,
                                            })}
                                            {...register("vehicle_rc_back", {
                                              required:
                                                "Vwehicle RC Back is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handleVehicleRCBackChange(e); // Your existing handler
                                              clearErrors("vehicle_rc_back"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.vehicle_rc_back && (
                                          <span className="text-danger">
                                            {errors.vehicle_rc_back.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {vehicleRCBackPreview && (
                                        <div className="mt-2">
                                          <img
                                            src={vehicleRCBackPreview}
                                            alt="Vehicle RC Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>
                                            Car Image Front
                                          </Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Car Image Front"
                                            className={classNames("", {
                                              "is-invalid":
                                                errors?.car_image_front,
                                            })}
                                            {...register("car_image_front", {
                                              required:
                                                "Car Image Front is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handleCarImageFrontChange(e); // Your existing handler
                                              clearErrors("car_image_front"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.car_image_front && (
                                          <span className="text-danger">
                                            {errors.car_image_front.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {CarImageFrontPreview && (
                                        <div className="mt-2">
                                          <img
                                            src={CarImageFrontPreview}
                                            alt="Car Image Front Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>

                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>
                                            Car Image Back
                                          </Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Car Image Back"
                                            className={classNames("", {
                                              "is-invalid":
                                                errors?.car_image_back,
                                            })}
                                            {...register("car_image_back", {
                                              required:
                                                "Car Image Back is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handleCarImageBackChange(e); // Your existing handler
                                              clearErrors("car_image_back"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.car_image_back && (
                                          <span className="text-danger">
                                            {errors.car_image_back.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {CarImageBackPreview && (
                                        <div className="mt-2">
                                          <img
                                            src={CarImageBackPreview}
                                            alt="Car Image Back Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>Puc Image</Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Puc Image"
                                            className={classNames("", {
                                              "is-invalid": errors?.puc_image,
                                            })}
                                            {...register("puc_image", {
                                              required: "Puc Image is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handlePucImageChange(e); // Your existing handler
                                              clearErrors("puc_image"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.puc_image && (
                                          <span className="text-danger">
                                            {errors.puc_image.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {pucImagePreview && (
                                        <div className="mt-2">
                                          <img
                                            src={pucImagePreview}
                                            alt="Car Image Front Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>

                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>
                                            Bank Detail Image
                                          </Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Bank Detail Image"
                                            className={classNames("", {
                                              "is-invalid":
                                                errors?.bank_detail_image,
                                            })}
                                            {...register("bank_detail_image", {
                                              required:
                                                "Bank Detail Image is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handleBankDetailImageChange(e); // Your existing handler
                                              clearErrors("bank_detail_image"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.bank_detail_image && (
                                          <span className="text-danger">
                                            {errors.bank_detail_image.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {bankDetailImagePreview && (
                                        <div className="mt-2">
                                          <img
                                            src={bankDetailImagePreview}
                                            alt="Car Image Back Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <div className="main-form-section mt-3">
                                      <Form.Group>
                                        <div className="text-center">
                                          <Form.Label>
                                            Insurance Image
                                          </Form.Label>
                                        </div>
                                        <InputGroup>
                                          <Form.Control
                                            type="file"
                                            name="image"
                                            placeholder="Insurance Image"
                                            className={classNames("", {
                                              "is-invalid":
                                                errors?.insurance_image,
                                            })}
                                            {...register("insurance_image", {
                                              required:
                                                "Insurance Image is required",
                                            })}
                                            accept="image/*"
                                            onChange={(e) => {
                                              handleInsuranceImageChange(e); // Your existing handler
                                              clearErrors("insurance_image"); // Clears error when user starts typing
                                            }}
                                          />
                                        </InputGroup>
                                        {errors.insurance_image && (
                                          <span className="text-danger">
                                            {errors.insurance_image.message}
                                          </span>
                                        )}
                                      </Form.Group>
                                      {insuranceImagePreview && (
                                        <div className="mt-2">
                                          <img
                                            src={insuranceImagePreview}
                                            alt="Car Image Front Preview"
                                            style={{ maxWidth: "100px" }}
                                          />
                                        </div>
                                      )}
                                    </div>
                                  </Col>
                                </Row>

                                <Row className="mt-5 pb-3">
                                  <div className="d-flex justify-content-center">
                                    <Link>
                                      <CancelButton
                                        name={"cancel"}
                                        handleClose={props.handleClose}
                                      />
                                    </Link>
                                    <SaveButton
                                      name={"save"}
                                      handleSubmit={handleSubmit(onSubmit)}
                                    />
                                  </div>
                                </Row>
                              </Col>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
